import { ActionPlanParams } from "./types";
import { roundToNDecimalPlaces } from "@dcc/common/rounding";
import { Sex } from "drinkaware-tools-api-library/dist/src/clients/users/src";
import { AppGenderToApiSex } from "../../utils";

const buildQueryString = (actionPlanParams: ActionPlanParams) => {
  const calories_week = roundToNDecimalPlaces(
    actionPlanParams.caloriesPerWeek,
    2
  ).toString();
  const units_week = roundToNDecimalPlaces(
    actionPlanParams.unitsPerWeek,
    2
  ).toString();
  const apiSex: Sex = AppGenderToApiSex(actionPlanParams.gender);
  return (
    `percentage=${actionPlanParams.percentage}` +
    `&dropped_days=${actionPlanParams.droppedDays.toString()}` +
    `&calories_week=${calories_week}` +
    `&units_week=${units_week}` +
    `&tips=${actionPlanParams.tips.toString()}` +
    `&num_drinking_days=${actionPlanParams.numDrinkingDays}` +
    `&gender=${apiSex}`
  );
};

export const buildActionPlanUrl = (actionPlanParams: ActionPlanParams) =>
  `${process.env.VUE_APP_ACTIVITY_PLAN_URL}?` +
  buildQueryString(actionPlanParams);
